import React from "react";
import { Services } from "../Services/Services";
import { Hero } from './components/Hero';
import { Contact } from "../Contact/Contact";
import { Videos } from "./components/Videos";
import { Avis } from "./components/Avis";


export const Home = () => {

    return (
        <div>
            <Hero />
            <main>
                <Services />
                <Avis />
                <Contact />
                <Videos />
            </main>
        </div>
    )

}

